<template>
  <b-modal class="modal-md" size="md" id="informationModal" ref="informationModal" :title="'Information'" :header-bg-variant="'secondary'" @show="autoHideModal()" centered hide-backdrop hide-footer okVariant="secondary" @hide="hideOverlay()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'info']" size="1x" class="mr-2"/>{{ t(informationTextTitle, informationTextTitle) }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="col-12 text-center">
        <h5>{{ t(informationTextKey, informationTextKey) }}</h5>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InformationModal',
  props: ['informationTextKey', 'informationTextTitle'],
  methods: {
    hideOverlay() {
        this.$parent.overlayActive = false
        this.$parent.alertShowing = false
        this.$root.$emit('bv::hide::modal', 'informationModal')
    },
    autoHideModal() {
      setTimeout(() => this.hideOverlay(), 5000);
    }
  }
}
</script>

<style scoped>

</style>
